import React from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import "./ConfirmationModal.scss";

const ConfirmationModal = ({
  open,
  onClose,
  icon,
  title,
  subtitle,
  message,
  children,
  actions,
  confirmText,
  cancelText,
  onConfirm,
  disableBackdropClick = false,
  hideCloseIcon = false,
  confirmButtonProps = {},
  cancelButtonProps = {},
  customClassName = "",
}) => {
  const handleClose = (event, reason) => {
    if (disableBackdropClick && reason === "backdropClick") {
      return;
    }
    onClose?.();
  };

  const showDefaultButtons = confirmText || cancelText;

  return (
    <Modal
      open={open}
      onClose={handleClose}
      className="GenericModal"
      disableEscapeKeyDown={disableBackdropClick}
    >
      <div className={`modalContainer ${customClassName}`}>
        <Box>
          {/* Close Icon */}
          {!hideCloseIcon && (
            <IconButton className="closeModal" onClick={onClose}>
              <HighlightOffIcon />
            </IconButton>
          )}

          {/* Icon */}
          {icon && (
            <Box className="modalImageWrapper">
              <img src={icon} alt="icon" />
            </Box>
          )}

          {/* Title */}
          {title && (
            <Typography className="modalTitle" variant="h6" component="h2">
              {title}
            </Typography>
          )}

          {/* Subtitle */}
          {subtitle && (
            <Typography className="modalSubtitle" sx={{ mb: 2 }}>
              {subtitle}
            </Typography>
          )}

          {/* Message (simple confirmation text) */}
          {message && (
            <Typography   sx={{
            mb: 2,
            textAlign: "center",     // centers text horizontally
            display: "flex",
            justifyContent: "center", // centers multi-line text if wrapped
            alignItems: "center",
          }} className="modalMessage">
              {message}
            </Typography>
          )}

          {/* Custom Content */}
          {children && <div className="modalBody">{children}</div>}

          {/* Actions */}
          <Box className="modalActions">
            {actions ? (
              actions
            ) : showDefaultButtons ? (
              <>
                {confirmText && (
                  <Button
                    variant="contained"
                    onClick={onConfirm}
                    sx={{
                      width: { xs: "100%", sm: "180px", md: "214px" },
                      height: "48px",
                      borderRadius: "8px",
                      padding: "12px 20px",
                      background: "#1A407D",
                      color: "#fff",
                      fontSize: "16px",
                      fontWeight: 600,
                      textTransform: "capitalize",
                      "&:hover": { backgroundColor: "#092552" },
                    }}
                    {...confirmButtonProps}
                  >
                    {confirmText}
                  </Button>
                )}
                {cancelText && (
                  <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{
                      width: { xs: "100%", sm: "180px", md: "214px" },
                      height: "48px",
                      borderRadius: "8px",
                      padding: "12px 20px",
                      fontSize: "16px",
                      fontWeight: 600,
                      textTransform: "capitalize",
                    }}
                    {...cancelButtonProps}
                  >
                    {cancelText}
                  </Button>
                )}
              </>
            ) : null}
          </Box>
        </Box>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
